import styled from 'styled-components';
import {TreatImagesInfoModal as TreatImagesInfoModalComponent} from './TreatImagesInfoModal';

export const IdentityContainer = styled.div``;

export const TreatImagesInfoModal = styled(TreatImagesInfoModalComponent)`
  margin-bottom: 12px;
`;
